// extracted by mini-css-extract-plugin
export var button = "ReactivateCTA_button__-FmcM";
export var container = "ReactivateCTA_container__JQlD3";
export var cta = "ReactivateCTA_cta__JAcVm";
export var desc = "ReactivateCTA_desc__drL+P";
export var icon = "ReactivateCTA_icon__XFh-d fal";
export var mobile = "ReactivateCTA_mobile__hx3BZ";
export var shoppingBag = "ReactivateCTA_shoppingBag__KMtyf fa-shopping-bag";
export var title = "ReactivateCTA_title__PvNJO";